import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, take, catchError } from 'rxjs/operators';
import { Auth, authState } from '@angular/fire/auth';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const auth = inject(Auth);

  // First check if we have a synchronous user
  if (auth.currentUser) {
    return of(true);
  }

  // If no synchronous user, wait for the auth state to be ready
  return authState(auth).pipe(
    take(1),
    map(user => {
      if (user) {
        return true;
      } else {
        router.navigate(['/auth'], { queryParams: { returnUrl: state.url } });
        return false;
      }
    }),
    catchError((error) => {
      console.error('Auth guard: Error checking auth state:', error);
      // Try fallback to currentUser
      if (auth.currentUser) {
        return of(true);
      } else {
        router.navigate(['/auth'], { queryParams: { returnUrl: state.url } });
        return of(false);
      }
    })
  );
};
